// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_B1c","cls2":"LoswpTabsHero-cls2_e9g LoswpTabsHero-cls1_B1c"};